import { render } from "./changegender.vue?vue&type=template&id=ac3c0c44&scoped=true"
import script from "./changegender.vue?vue&type=script&lang=js"
export * from "./changegender.vue?vue&type=script&lang=js"

import "./changegender.vue?vue&type=style&index=0&id=ac3c0c44&lang=scss&scoped=true"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac3c0c44"]])

export default __exports__